import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "./App.css";
import Login from "./Pages/Login/Login";
import { getUserRole } from "./Utils/Common";
import Unauthorized from "./Components/Unautorized/Unauthorized";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Customer from "./Pages/Customer/Customer";
import ExpenseType from "./Pages/ExpenseType/ExpenseType";
// import Expense from "./Pages/Expense/Expense";
// import ExpenseForm from "./Pages/Expense/ExpenseForm";
import Branch from "./Pages/Branch/Branch";
import TestAndPrice from "./Pages/TestAndPrice/TestAndPrice";
import User from "./Pages/User/User";
import EndOfDay from "./Pages/EndOfDay/EndOfDay";
import SalesReport from "./Pages/Reports/SalesReport";
import ExpenseReport from "./Pages/Reports/ExpenseReport";
import ProfitAndLossReport from "./Pages/Reports/ProfitAndLossReport";
import AccountReceivableReport from "./Pages/Reports/AccountReceivableReport";
import PaymentReport from "./Pages/Reports/PaymentReport";
import EndOfDayForm from "./Pages/EndOfDay/EndOfDayForm";
import PurchaseRequest from "./Pages/PurchaseRequest/PurchaseRequest";
import PurchaseRequestForm from "./Pages/PurchaseRequest/PurchaseRequestForm";
import PurchaseOrder from "./Pages/PurchaseOrder/PurchaseOrder";
import PurchaseOrderForm from "./Pages/PurchaseOrder/PurchaseOrderForm";
import ViewPurchaseOrder from "./Pages/PurchaseOrder/ViewPurchaseOrder";
import PettyCashEntry from "./Pages/PettyCash/PettyCashEntry";
import PettyCashEntryForm from "./Pages/PettyCash/PettyCashEntryForm";
import PettyCashOutForm from "./Pages/PettyCash/PettyCashOutForm";
import PettyCashOut from "./Pages/PettyCash/PettyCashOut";
import PaymentRequest from "./Pages/PaymentRequest/PaymentRequest";
import PaymentRequestForm from "./Pages/PaymentRequest/PaymentRequestForm";
import DailySalesReport from "./Pages/DailySalesReport/DailySalesReport";
import DailySalesReportForm from "./Pages/DailySalesReport/DailySalesReportForm";
import CreditBillingStatement from "./Pages/CreditBillingStatement/CreditBIllingStatement";
import CreditBillingStatementForm from "./Pages/CreditBillingStatement/CreditBillingStatementForm";
import ViewCreditBillingStatement from "./Pages/CreditBillingStatement/ViewCreditBIllingStatement";
import CreditBillingPayment from "./Pages/CreditBillingPayment/CreditBillingPayment";
import CreditBillingPaymentForm from "./Pages/CreditBillingPayment/CreditBillingPaymentForm";
import Discount from "./Pages/Discount/Discount";
import BorrowedCash from "./Pages/BorrowedCash/BorrowedCash";
import AdvancePayment from "./Pages/AdvancePayment/AdvancePayment";
import DiscountForm from "./Pages/Discount/DiscountForm";

interface ProtectedRouteProps {
  element: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  const location = useLocation();
  const user = getUserRole();
  const routeBasedAccess = {
    teller: ["/home", "/general-details"],
    admin: ["/home"],
  };

  const validateAccess = () => {
    if (user === "admin") {
      return routeBasedAccess.teller.some((path) =>
        location.pathname.startsWith(path)
      );
    }
  };

  return validateAccess() ? <>{element}</> : <Unauthorized />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        <Route path="/customer" element={<Customer />} />
        <Route path="/expense-type" element={<ExpenseType />} />
        <Route path="/test-price" element={<TestAndPrice />} />
        <Route path="/user" element={<User />} />
        <Route path="/petty-cash-entry" element={<PettyCashEntry />} />
        <Route path="/petty-cash-out" element={<PettyCashOut />} />
        <Route
          path="/petty-cash-entry/add"
          element={<PettyCashEntryForm add />}
        />
        <Route
          path="/petty-cash-entry/edit/:id"
          element={<PettyCashEntryForm edit />}
        />
        <Route
          path="/petty-cash-entry/view/:id"
          element={<PettyCashEntryForm view />}
        />
        <Route
          path="/petty-cash/add"
          element={<PettyCashOutForm add />}
        />
        <Route
          path="/petty-cash/view/:id"
          element={<PettyCashOutForm view />}
        />
        <Route
          path="/petty-cash/edit/:id"
          element={<PettyCashOutForm edit />}
        />
        <Route path="/purchase-request" element={<PurchaseRequest />} />
        <Route
          path="/purchase-request/add"
          element={<PurchaseRequestForm add />}
        />
        <Route
          path="/purchase-request/edit/:id"
          element={<PurchaseRequestForm edit />}
        />
        <Route
          path="/purchase-request/view/:id"
          element={<PurchaseRequestForm view />}
        />
        <Route
          path="/purchase-request/approval/:id"
          element={<PurchaseRequestForm approval />}
        />
        <Route path="/purchase-order" element={<PurchaseOrder />} />
        <Route path="/purchase-order/add" element={<PurchaseOrderForm add />} />
        <Route
          path="/purchase-order/edit/:id"
          element={<PurchaseOrderForm edit />}
        />
        <Route
          path="/purchase-order/view/:id"
          element={<PurchaseOrderForm view />}
        />
        <Route
          path="/purchase-order/approval/:id"
          element={<PurchaseOrderForm approval />}
        />
        <Route path="/payment-request" element={<PaymentRequest />} />
        <Route
          path="/payment-request/add"
          element={<PaymentRequestForm add />}
        />
        <Route
          path="/payment-request/edit/:id"
          element={<PaymentRequestForm edit />}
        />
        <Route
          path="/payment-request/view/:id"
          element={<PaymentRequestForm view />}
        />
        <Route
          path="/payment-request/approval/:id"
          element={<PaymentRequestForm approval />}
        />
        <Route path="/branch" element={<Branch />} />
        <Route path="/end-of-day" element={<EndOfDay />} />
        <Route path="/end-of-day/add" element={<EndOfDayForm add />} />
        <Route path="/end-of-day/view/:id" element={<EndOfDayForm view />} />
        <Route path="/end-of-day/edit/:id" element={<EndOfDayForm edit />} />
        <Route path="/end-of-day/check/:id" element={<EndOfDayForm check />} />
        <Route path="/end-of-day/approval/:id" element={<EndOfDayForm approval />} />
        <Route path="/daily-sales-report" element={<DailySalesReport />} />
        <Route path="/daily-sales-report/edit/:id" element={<DailySalesReportForm />} />
        <Route path="/daily-sales-report/view/:id" element={<DailySalesReportForm />} />
        <Route
          path="/credit-billing-statement"
          element={<CreditBillingStatement />}
        />
        <Route
          path="/credit-billing-statement/add"
          element={<CreditBillingStatementForm add />}
        />
        <Route
          path="/credit-billing-statement/edit/:id"
          element={<CreditBillingStatementForm edit />}
        />
        <Route
          path="/credit-billing-statement/review/:id"
          element={<CreditBillingStatementForm review/>}
        />
        <Route
          path="/credit-billing-statement/approval/:id"
          element={<CreditBillingStatementForm approval/>}
        />
        <Route
          path="/credit-billing-payment"
          element={<CreditBillingPayment />}
        />
        <Route
          path="/credit-billing-payment/add"
          element={<CreditBillingPaymentForm add />}
        />
        <Route path="/discount"             element={<Discount     />} />
        <Route path="/discounts/add"        element={<DiscountForm add/>} />
        <Route path="/discounts/edit/:id"   element={<DiscountForm edit />} />
        <Route
          path="/borrowed-cash"
          element={<BorrowedCash />}
        />
        <Route path="/sales-report" element={<SalesReport />} />
        <Route path="/expense-report" element={<ExpenseReport />} />
        <Route path="/profit-and-loss-report" element={<ProfitAndLossReport />} />
        <Route path="/account-receivable-report" element={<AccountReceivableReport />} />
        <Route path="/payment-report" element={<PaymentReport />} />   
        <Route path="/advance-payment" element={<AdvancePayment />} />   
      </Routes>
    </Router>
  );
}

export default App;
